import { render, staticRenderFns } from "./update-activation.vue?vue&type=template&id=5c167eda&"
import script from "./update-activation.vue?vue&type=script&lang=ts&"
export * from "./update-activation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports